import type { KeyboardEvent } from 'react'

/**
 * Wraps a click handler so it also fires on Enter and Space when the element
 * has focus. Pair with `role="button"` and `tabIndex={0}` to make
 * non-interactive elements (divs, svgs, spans) keyboard-accessible without
 * restructuring them into <button>.
 *
 * Returns undefined when handler is undefined so attribute presence tracks
 * the underlying onClick.
 */
export function onKeyboardClick<E = HTMLElement>(
	handler: ((evt: any) => void) | undefined,
): ((e: KeyboardEvent<E>) => void) | undefined {
	if (!handler) return undefined
	return (e: KeyboardEvent<E>) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault()
			handler(e)
		}
	}
}
